import React from 'react';
import { connect } from 'react-redux';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_GA_ACCOUNTS } from 'apps/auth/constants/UrlConstants';

const GlobalAccountStubPage = (props) => {
    return (
        <BaseLayout stateOptions={{ isGA: true }}>
            <InfoPage
                topButtonType={'link'}
                topButtonCaption={props.notNow}
                topButtonOnClick={(e) => {
                    e.preventDefault();
                    if (props.redirectNotNow) {
                        window.location.href = props.redirectNotNow;
                    } else {
                        window.history.back();
                    }
                }}
                topButtonLink={AUTH_GA_ACCOUNTS}
                iconName={'paysend-logo-globe'}
                iconColor={'primary'}
                headerText={props.title}
                secondaryText={props.info}
                primaryButtonCaption={props.getApp}
                primaryButtonType={'link'}
                primaryButtonLink={props.appLink}
            />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        appLink: state.extra.appLink,
        redirectNotNow: state.extra.linkForNotNow,
        title: state.messages.pageMessages.stubPageTitle,
        info: state.messages.pageMessages.stubPageInfo,
        getApp: state.messages.pageMessages.stubPageGetApp,
        notNow: state.messages.pageMessages.stubPageNotNow,
    };
};

export default connect(mapStateToProps)(BasePage(GlobalAccountStubPage));
